import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router";
import App from "./pages/homepage/App";
import ManageProfile from "./pages/manage-profile/manage-profile";
import { AutoFillProvider } from "./services/user/auto-fill-signup";
import { AvatarNotiList } from "@eclear-ag/ec-common-ui";
import Reports from "./pages/reports";
import { ManageProfileProvider } from "./services/manage-profile/manageProfile";
import UpgradeWizardRoute from "./components/manage-profile/subscriptions/upgrade-wizard-route";
import ConsentPreviewRoute from "./components/manage-profile/subscriptions/consent-preview-route";
import { CircularProgress } from "@mui/material";
import { FormattedMessage } from "react-intl";
import {
  EcUserDataContext,
  Error404,
  Error403Role,
  Error403Subscription
} from "@eclear-ag/ec-common-ui";
import { MAWBKPI } from "./pages/ClearCustoms/MAWBKPI";
import { canAccessClearCustoms } from "./pages/ClearCustoms/tools/tool";

export default function RouterOutlet() {
  const { userData } = useContext(EcUserDataContext);

  function PageLoad() {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <CircularProgress />
        <div>
          <FormattedMessage id={"loading"} />
          ...
        </div>
      </div>
    );
  }

  const isClearCustomsUser = canAccessClearCustoms({ userData });
  const restrictForClearCustoms = (element) =>
    isClearCustomsUser ? <Navigate to="/spot/403-role" replace /> : element;

  return !userData ? (
    <PageLoad />
  ) : (
    <Routes>
      <Route path="/spot" element={<App />} />
      <Route path="/spot/mawb/:id" element={<MAWBKPI />} />
      <Route
        path="/spot/avatar"
        element={restrictForClearCustoms(<AvatarNotiList />)}
      />
      <Route
        path="/spot/avatar/reports"
        element={restrictForClearCustoms(<Reports />)}
      />
      <Route
        path="/spot/manage-profile"
        element={
          <ManageProfileProvider>
            <AutoFillProvider>
              <ManageProfile />
            </AutoFillProvider>
          </ManageProfileProvider>
        }
      />
      <Route
        path="/spot/manage-profile/subscriptions/:productType"
        element={
          <ManageProfileProvider>
            <AutoFillProvider>
              <ManageProfile />
            </AutoFillProvider>
          </ManageProfileProvider>
        }
      />
      <Route
        path="/spot/manage-profile/upgrade"
        element={<UpgradeWizardRoute />}
      />
      {/* Design preview for the VATRules consent screen — sample figures only,
          nothing is charged. See consent-preview-route.js for the query params. */}
      <Route
        path="/spot/manage-profile/consent-preview"
        element={<ConsentPreviewRoute />}
      />

      <Route
        path="/spot/403-subscription"
        element={<Error403Subscription appName="SPOT" />}
      />
      <Route path="/spot/403-role" element={<Error403Role />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
